import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib';
import input from '@scoutgg/ftw/source/decorators/input';
import { Team } from '../../../models';
import template from './player-list-modal.jade';

@Component('sporty')
@Template(template)
@Attribute('team', Team)
@Attribute('players', Array)
@Attribute('unavailablePlayerIds', Array)
@input('onPlayerSelect', Function)
export default class PlayerListModal extends HTMLElement {
  attached() {
    this.render();
  }

  isPlayerUnavailable(player) {
    return this.unavailablePlayerIds?.includes(player._id) || false;
  }

  selectPlayer(player) {
    if (this.isPlayerUnavailable(player) || !this.onPlayerSelect) {
      return;
    }

    this.onPlayerSelect(player);
    this.closest('ft-modal')?.remove();
  }
}
